import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxGalleryComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { GalleryModel, GalleryStyle } from '../../../base/src/abcGallery/abcGallery';

@Component({
    selector: '',
    template: `<div class="devExGalleryStyle" id="gallery-id" [ngClass]="{ visibilityStyle: dataSource.length == 1 }">
      <dx-gallery
        #dxGallery
        [id]="attrId"
        [height]="height"
        [width]="width"
        [showIndicator]="showIndicator"
        [showNavButtons]="showNavButtons"
        [loop]="loop"
        [visible]="visible"
        [disabled]="disabled"
        [rtlEnabled]="rtlEnabled"
        [class]="class"
        [animationEnabled]="animationEnabled"
        [animationDuration]="animationDuration"
        [swipeEnabled]="swipeEnabled"
        [hoverStateEnabled]="hoverStateEnabled"
        [initialItemWidth]="initialItemWidth"
        [wrapAround]="wrapAround"
        [noDataText]="noDataText"
        [slideshowDelay]="slideshowDelay"
        [focusStateEnabled]="focusStateEnabled"
        [(selectedIndex)]="selectedIndexAttr"
        (onItemClick)="itemClick($event)"
        (onSelectionChanged)="selectionChanged()"
        (onItemContextMenu)="itemContextMenu($event)"
        (onItemHold)="itemHold($event)"
        (onOptionChanged)="optionChnaged($event)"
        (onInitialized)="initialized($event)"
        (onContentReady)="contentReady($event)"
        [(dataSource)]="dataSource"
        >
        <div *dxTemplate="let data of 'item'">
          @if (data.text) {
            <span class="groupName">{{ data.text }}</span>
          }
          @if (loadHtml) {
            <div>
              @if (data.cbxGroupDataSource) {
                <dx-select-box
                  #selectBox
                  [items]="data.cbxGroupDataSource"
                  class="groupList"
                  [ngClass]="{ singleGalleryItem: dataSource.length == 1 }"
                  [width]="selectBoxWidth"
                  [rtlEnabled]="rtlEnabled"
                  [value]="data.cbxGroupDataSource[selectedIndexAttr]"
                  [readOnly]="dataSource.length === 1 ? true : false"
                  [stylingMode]="'none'"
                  [dropDownOptions]="{ animation: null }"
                  (onValueChanged)="valueChanged($event)"
                  (onContentReady)="selectBoxContentReady($event)"
                  (onOpened)="onOpened($event)"
                ></dx-select-box>
              }
            </div>
          }
        </div>
      </dx-gallery>
    </div>`,
    styleUrls: ['./devExGallery.component.scss'],
    standalone: false
})
export class DevExGalleryComponent implements OnInit {
  @ViewChild('dxGallery', { static: true }) dxGallery: DxGalleryComponent;
  @ViewChild('selectBox', { static: false }) selectBox: DxSelectBoxComponent;

  @Input() dataSource: GalleryModel[] | any;
  @Input() attrId: string;
  @Input() width: string | number;
  @Input() height: string | number;
  @Input() disabled: boolean = false;
  @Input() visible: boolean;
  @Input() focusStateEnabled: boolean = false;
  @Input() loop: boolean = false;
  @Input() noDataText: string = '';
  @Input() swipeEnabled: boolean = true;
  @Input() animationEnabled: boolean = true;
  @Input() animationDuration: number;
  @Input() showIndicator: boolean = true;
  @Input() showNavButtons: boolean = false;
  @Input() slideshowDelay: number;
  @Input() initialItemWidth: string | number;
  @Input() hoverStateEnabled: boolean;
  @Input() wrapAround: boolean;
  @Input() rtlEnabled: boolean;
  @Input() class: string;
  @Output() onItemClick = new EventEmitter();
  @Output() onItemContextMenu = new EventEmitter();
  @Output() onItemHold = new EventEmitter();
  @Output() onOptionChanged = new EventEmitter();
  @Output() onSelectionChanged = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  @Output() indexChanged = new EventEmitter();
  @Input() selectedIndex: number = 0;
  @Input() loadHtml: boolean = false;
  @Input() showSelectBox: boolean = true;
  public selectedIndexAttr: number = 0;
  public selectBoxWidth: number;
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  public contentReady(e) {
    if (this.selectedIndex) {
      this.dxGallery.instance.option('selectedIndex', this.selectedIndex);
      this.onContentReady.emit(e);
    }
    // e.element.children[0].children[0].children[0].children[0].appendChild(this.dataSource[0].html);
    if (this.loadHtml && this.dataSource.length !== 0) {
      document.querySelectorAll('.dx-item-content.dx-gallery-item-content')[0]?.appendChild(this.dataSource[0].html);
    }
    this.changeDetectorRef.detectChanges();
  }

  public selectionChanged() {
    this.onSelectionChanged.emit(this.selectedIndexAttr);
    // e.element.children[0].children[0].children[this.selectedIndex].children[0].appendChild(this.dataSource[this.selectedIndex].html);
    if (this.loadHtml && this.dataSource.length !== 0) {
      document
        .querySelectorAll('.dx-item-content.dx-gallery-item-content')
        [this.selectedIndexAttr]?.appendChild(this.dataSource[this.selectedIndexAttr].html);
    }
    this.changeDetectorRef.detectChanges();
  }
  //dx-template-wrapper dx-item-content dx-gallery-item-content

  ngOnInit() {}

  public getSelectedIndex() {
    return this.selectedIndexAttr;
  }

  public itemClick(event) {
    this.onItemClick.emit(event);
  }

  public itemContextMenu(event) {
    this.onItemContextMenu.emit(event);
  }

  public itemHold(event) {
    this.onItemHold.emit(event);
  }

  public itemRefresh() {
    this.dxGallery.instance.repaint();
  }

  public optionChnaged(event) {
    this.onOptionChanged.emit(event);
  }

  public initialized(event) {}

  public goToItem(index: number, animation: boolean) {
    this.dxGallery.instance.goToItem(index, animation);
  }

  public updateDataSource(items) {
    this.dxGallery.dataSource = items;
    this.changeDetectorRef.detectChanges();
  }

  private measureTextWidth(text: string): number {
    const span = document.createElement('span');
    span.style.fontFamily = 'fira sans book';
    span.style.fontWeight = '200';
    span.style.fontSize = '20px';
    span.style.visibility = 'hidden';
    span.textContent = text;
    document.body.appendChild(span);

    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  }

  private getSelectedValueWidth(value) {
    this.selectBoxWidth = this.measureTextWidth(value) + 40;
  }

  public valueChanged(e) {
    let index = this.dataSource[0].cbxGroupDataSource.indexOf(e.value);
    this.indexChanged.emit(index);
    const selectedIndex = e.component.getDataSource().items().indexOf(e.value);
    this.dxGallery.instance.option('selectedIndex', selectedIndex);
    this.getSelectedValueWidth(e.value);
  }

  public selectBoxContentReady(e) {
    this.getSelectedValueWidth(e.component.option().displayValue);
  }
  public onOpened(e) {
    e.component._popup._$content[0].classList.add('groupList');
    e.component.option('dropDownOptions.resizeEnabled', true);
  }

  public setGalleryStyle(style: GalleryStyle) {
    if (style) {
      for (let key in style) {
        this[key] = style[key];
      }
    }
  }
}
